import { axios } from './commons';

export default {
  getAdmins: (pageNo = 1) => axios.get(`/administrators/?page=${pageNo}`),
  getAdminById: (id) => axios.get(`/administrators/${id}`),
  getSelfInfo: () => axios.get('/administrators/me'),
  createAdmin: ({ name, email, password, roles }) =>
    axios.post('/administrators', { name, email, password, roles }),
  editAdmin: ({ id, name, email, roles }) =>
    axios.put(`/administrators/${id}`, { name, email, roles }),
  deleteAdmin: (id) => axios.delete(`/administrators/${id}`),
};
